let pendingFocusSurface = null;

if (!customElements.get('cart-gift-wrap')) {
  class CartGiftWrap extends HTMLElement {
    constructor() {
      super();
      this.loading = false;
      this.handleOptionClick = this.handleOptionClick.bind(this);
    }

    connectedCallback() {
      this.accordion = this.querySelector('theme-accordion');
      this.trigger = this.querySelector('[data-accordion-trigger]');
      this.addEventListener('click', this.handleOptionClick);

      const surface = this.surface();
      if (pendingFocusSurface === surface) {
        pendingFocusSurface = null;
        this.trigger?.focus();
      }
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleOptionClick);
    }

    surface() {
      return this.closest('cart-drawer') ? 'drawer' : 'page';
    }

    async handleOptionClick(event) {
      const option = event.target.closest('[data-variant-id]');
      if (!option || this.loading) return;

      if (option.getAttribute('aria-current') === 'true') {
        this.accordion?.close();
        return;
      }

      const variantId = option.dataset.variantId;
      const currentLineKey = this.dataset.giftLineKey;
      const eligibleTitles = this.dataset.eligibleTitles || '';
      const surface = this.surface();

      this.accordion?.close();
      this.setLoading(true);
      theme.cart.errors.clearFooter();

      try {
        if (currentLineKey) {
          await theme.cart.change(currentLineKey, 0, { _silent: true });
        }

        const item = { id: variantId, quantity: 1 };
        if (eligibleTitles) item.properties = { '_Para los productos': eligibleTitles };

        pendingFocusSurface = surface;
        await theme.cart.add(item, { _internal: true, openDrawer: false });

        this.announceSelection(option);
      } catch (_) {
        pendingFocusSurface = null;
      } finally {
        this.setLoading(false);
      }
    }

    announceSelection(option) {
      if (!theme.settings?.cartActionToastsEnable) return;

      const title = option.querySelector('.cart-gift-wrap__option-title')?.textContent?.trim();
      const template = theme.locales?.cart?.success?.giftSelected;
      if (!title || !template) return;

      theme.toast?.show({ type: 'success', message: template.replace('[gift]', title) });
    }

    setLoading(isLoading) {
      this.loading = isLoading;
      if (this.trigger) this.trigger.disabled = isLoading;
    }
  }

  customElements.define('cart-gift-wrap', CartGiftWrap);
}
